export const NotFound = () => {
  return (
      <main className="py-24 container mx-auto">
        <NotFound />
      </main>
  );
}